import React from 'react';

type Props = {
    message   : string
    close     : callback
    fadeTime  : number
}

export default function InfoMessage(props:Props) {

    const classes = Classes("notification", "h-100-percent", "info")

    return (
        <div className={Classes(classes)} style={{transition: "opacity " + props.fadeTime + "s"}}>
            <div className="flex-row-left-center">
                <div className="left-indicator"></div>
                <div className="ii5-information icon ui5-color-action m-l-3"/>
                <div className="message ui5-txt-less-important">
                    {props.message}
                </div>
            </div>
            <div className="close i5-delete" onClick={props.close}/>
        </div>
    )

}
